import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./styles/theme";
import App from "./App";
import "./index.css";

// MSAL imports
import {
    PublicClientApplication,
    EventType,
    EventMessage,
    AuthenticationResult,
} from "@azure/msal-browser";
import { premiumMsalConfig } from "./authConfig.premium";
import { legacyMsalConfig } from "./authConfig.legacy";

// Create separate MSAL instances for premium and legacy markets
export const premiumMsalInstance = new PublicClientApplication(premiumMsalConfig);
export const legacyMsalInstance = new PublicClientApplication(legacyMsalConfig);

// Initialize both MSAL instances
Promise.all([
    premiumMsalInstance.initialize(),
    legacyMsalInstance.initialize()
]).then(() => {
    // Setup premium market instance
    const premiumAccounts = premiumMsalInstance.getAllAccounts();
    if (premiumAccounts.length > 0) {
        premiumMsalInstance.setActiveAccount(premiumAccounts[0]);
    }

    premiumMsalInstance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const payload = event.payload as AuthenticationResult;
            const account = payload.account;
            premiumMsalInstance.setActiveAccount(account);
        }
    });

    // Setup legacy market instance
    const legacyAccounts = legacyMsalInstance.getAllAccounts();
    if (legacyAccounts.length > 0) {
        legacyMsalInstance.setActiveAccount(legacyAccounts[0]);
    }

    legacyMsalInstance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const payload = event.payload as AuthenticationResult;
            const account = payload.account;
            legacyMsalInstance.setActiveAccount(account);
        }
    });

    const root = ReactDOM.createRoot(
        document.getElementById("root") as HTMLElement
    );
    root.render(
        <Router>
            <ThemeProvider theme={theme}>
                <App premiumPca={premiumMsalInstance} legacyPca={legacyMsalInstance} />
            </ThemeProvider>
        </Router>
    );
});
